import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import {
  checkAuthStatus,
  generateQR,
  sendImage,
  sendMessage,
  sendMultiplePhoneMessage,
  sendPdf
} from 'app/api-ws/whatsapp-ws';
import { Alert, Button, Grid, Snackbar, Typography } from '@mui/material';
import { getTreatmentByRefDoctorId } from 'app/api-ws/treatment-ws';
import useAuth from 'app/hooks/useAuth';

function WhatsApp() {
  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const [qrData, setQrData] = useState('');
  const [blur, setBlur] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoggedIn, setIsLoggeIn] = useState(false);
  const [appointmentData, setAppointmentData] = useState([]);
  const { user } = useAuth();
  useEffect(() => {
    fetchAppointmentDetails();
  }, []);
  const fetchAppointmentDetails = () => {
    getTreatmentByRefDoctorId(user?._id, user?.authToken)
      .then((res) => {
        setAppointmentData(res.data.data);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleBlur = () => {
    setBlur(false);
  };

  useEffect(() => {
    fetchAuthStatus();
    if (!blur) {
      const timer = setTimeout(() => {
        setBlur(true);
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, [blur]);

  const fetchQR = () => {
    toggleBlur();
    generateQR()
      .then((res) => {
        setQrData(res.data);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchAuthStatus = () => {
    checkAuthStatus()
      .then((res) => {
        if (res.data == '') {
          setIsLoggeIn(false);
          setSnackBarMessage('Please Login Again');
          setSnackBarType('error');
          showSnackBar();
        } else if (res.data == 'CONNECTED') {
          setIsLoggeIn(true);
          setSnackBarMessage('Already Logged in');
          setSnackBarType('success');
          showSnackBar();
        } else {
          setIsLoggeIn(false);
          setSnackBarMessage('Error, Please Login Agian ');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log('Error', err);
      });
  };

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }
  const today = new Date().toISOString().split('T')[0];

  const appointmentsForToday = appointmentData.filter((data) => {
    const nextVisitDate = data.appointment?.nextVisitDate;

    // Check if nextVisitDate is defined and is a valid date string
    if (nextVisitDate && !isNaN(Date.parse(nextVisitDate))) {
      const formattedDate = new Date(nextVisitDate).toISOString().split('T')[0];
      return formattedDate === today; // This will give you the date in YYYY-MM-DD format
    } else {
      // Ignore appointments with invalid dates
      return false;
    }
  });

  const sendWhatsappMultipleMessage = () => {
    const arrayOfNumbers = appointmentData?.map((obj) => obj?.refPatientId?.phone);
    console.log(arrayOfNumbers);

    const smsRequest = {
      phones: [916362718708, 918495042408],
      message: 'HI bamboo'
    };
    sendMultiplePhoneMessage(smsRequest)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sendWhatsappMessage = () => {
    const whatsappRequest = {
      phone: '918495042408',
      message: 'Hi bharath'
    };
    sendMessage(whatsappRequest)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sendWhatsappImage = () => {
    const imageRequest = {
      phone: '918495042408',
      message: 'Hi bharath',
      image: 'aserfaf'
    };
    sendImage(imageRequest)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = (error) => reject(error);
    });
  };
  const sendWhatsappPDF = async () => {
    const base64String = await convertToBase64(selectedFile);
    const pdfRequest = {
      phone: '918495042408',
      pdf: base64String,
      filename: selectedFile.name
    };
    sendPdf(pdfRequest)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFileChange = (event) => {
    console.log(event.target.files);
    setSelectedFile(event.target.files[0]);
  };
  return (
    <div style={{ paddingTop: '10vh', display: 'flex', flexDirection: 'column' }}>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      {isLoggedIn ? null : (
        <div style={{ display: 'flex', justifyContent: 'center', height: '30vh' }}>
          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                filter: blur ? 'blur(4px)' : 'none'
              }}
            >
              <QRCode value={qrData} />
            </div>
            {blur && (
              <Button
                onClick={fetchQR}
                variant="contained"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  backgroundColor: '#66b5a3',
                  color: 'white',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1
                }}
              >
                Generate QR
              </Button>
            )}
          </div>
        </div>
      )}
      <div
        style={{
          marginTop: '50px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div style={{ marginBottom: '20px' }}>
          {isLoggedIn ? (
            <div>
              <p>Today: {today}</p>
              {appointmentsForToday?.map((data) => {
                console.log(data);
                return (
                  <div>
                    <p>Name: {data?.refPatientId?.patientName}</p>
                    <p>Ph no: {data?.refPatientId?.phone}</p>
                    <p>Consultant: {data?.refConsultantName}</p>
                  </div>
                );
              })}
              <Button
                variant="contained"
                style={{ backgroundColor: '#66b5a3', color: 'white' }}
                onClick={sendWhatsappMultipleMessage}
              >
                {' '}
                Send sms
              </Button>
            </div>
          ) : null}
        </div>

        {/* <div>
          <button onClick={sendWhatsappImage} style={{ marginRight: '10px' }}>
            sendImage
          </button>
          <input type="file" accept="application/pdf" onChange={handleFileChange} />
          <button onClick={sendWhatsappPDF} style={{ marginLeft: '10px' }}>
            send PDF
          </button>
        </div> */}
      </div>
    </div>
  );
}

export default WhatsApp;
